module.exports = __webpack_public_path__ + "img/6.dad456b4.jpg";